<template>
    <div class="pcr-partner-establishements">
        <div class="tab-contextual-button">
            <el-tooltip placement="top" content="Ajouter un établissement" effect="light" :open-delay="300" v-if="$currentTreeNode.Rights.GrantLevel >= $grantLevel.administrator">
                <el-button @click="showAddModal = true">
                    <i class="fa fa-home" aria-hidden="true"></i>
                    <i class="fa fa-plus" aria-hidden="true"></i>
                </el-button>
            </el-tooltip>
        </div>
        
        <add-establishment-modal :visible.sync="showAddModal" :post-url="`/api/partner/${this.nodeId}/establishment`"></add-establishment-modal>
    
        <el-input placeholder="Recherche" v-model="filterText" class="table-search"></el-input>
        <el-table ref="table" :data="searchFilteredEstablishments" border :default-sort="{prop: 'EstablishmentId', order: 'ascending'}" style="width: 100%" highlight-current-row @current-change="currentChange">
            <el-table-column prop="EstablishmentId" label="Id" sortable width="80px"></el-table-column>
            <el-table-column prop="EstablishmentName" label="Nom" sortable></el-table-column>
            <el-table-column prop="Type" label="Type" sortable></el-table-column>
            <el-table-column prop="Status" label="Statut" sortable></el-table-column>
            <el-table-column label="" width="84px" class-name="cell-action" v-if="$currentTreeNode.Rights.GrantLevel >= $grantLevel.administrator">
                <template slot-scope="scope">
                    <el-dropdown trigger="click">
                        <el-button @click.stop>Actions <i class="fa fa-caret-down" aria-hidden="true"></i></el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item>
                                <remove-establishment :establishment-id="scope.row.EstablishmentId" :name="scope.row.EstablishmentName"></remove-establishment>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import Vue from 'vue';
import ZoneList from '../cross-components/mixins/zone-list.vue';
export default Vue.component('partner-establishment-list', {
    mixins: [ZoneList],
    methods: {
        refresh() {
            if (!this.refreshing) {
                this.refreshing = true;

                this.$http.get('/api/partner/' + this.nodeId + '/establishments').then((response) => {
                    this.establishments = response.data;
                    this.refreshing = false;
                });
            }
        }
    }
});
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/admin/partner/partner-establishment-list.vue